// 드롭다운 훅

import { useState } from 'react'

export const useDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return {isOpen, open, close};
}
